import PuzzleService from '_services/rest/modules/puzzle';

export default {
  state: {
    shapeLinks: null,
    hasChanges: false,
  },
  mutations: {
    setShapeLinks(state, shapeLinks) {
      state.shapeLinks = shapeLinks;
    },
    setHasChanges(state, status) {
      state.hasChanges = status;
    },
  },
  actions: {
    setShapeLinks({ commit }, model) {
      commit('setShapeLinks', model);
    },
    setHasChanges({ commit }, status) {
      commit('setHasChanges', status);
    },
    getShapeLinks({ commit }, id) {
      PuzzleService.getPuzzleById(id)
        .then(response => {
          commit('setShapeLinks', response);
          commit('setHasChanges', false);
        });
    },
  },
};
